import React from 'react';
import {
  type DrawerMenuItem,
  type MobileHeaderPageStackItem,
  navItemType,
  type SiteConfig,
} from '@cx-web/domain-types';

import LinkWithPage from '../LinkWithPage/index';
import SingleLink from '../SingleLink/index';

interface DrawerMenuLinksProps {
  bookmakers: SiteConfig['bookmakers'];
  hideIcons?: boolean;
  label?: string;
  pageClick: (item: MobileHeaderPageStackItem) => void;
  pageDepth?: number;
  pages: DrawerMenuItem[];
  serverUrl: string;
  trackMenu?: (text: string) => void;
}

function DrawerMenuLinks({
  bookmakers,
  hideIcons = false,
  label = 'hamburger_icon',
  pageClick,
  pageDepth = 0,
  pages,
  serverUrl,
  trackMenu,
}: DrawerMenuLinksProps): React.JSX.Element {
  return (
    <div data-nested-menu-label={label}>
      {(pages || []).map(page => {
        if (!page) {
          return null;
        }

        const isSingleLink = page?.type === navItemType.LINK;

        if (isSingleLink) {
          return (
            <SingleLink
              callback={trackMenu}
              hideIcons={hideIcons}
              key={page.name}
              label={label}
              page={page}
              pageDepth={pageDepth}
              serverUrl={serverUrl}
            />
          );
        }

        return (
          <LinkWithPage
            bookmakers={bookmakers}
            callback={trackMenu}
            hideIcons={hideIcons}
            key={page.name}
            label={label}
            page={page}
            pageClick={pageClick}
            renderMenuLinks={(pages, subLabel) => (
              <DrawerMenuLinks
                bookmakers={bookmakers}
                label={subLabel}
                pageClick={pageClick}
                pages={pages}
                serverUrl={serverUrl}
                trackMenu={trackMenu}
              />
            )}
            serverUrl={serverUrl}
          />
        );
      })}
    </div>
  );
}

export default DrawerMenuLinks;
